import Vue from 'vue'
import Router from 'vue-router'
import config from '../config'
import Login from '../views/login/index.vue'
import Layout from '../layout/index.vue'
import Dashboard from '../views/dashboard/index.vue'
import StudentsPage from '../views/students/index.vue'
import ClassesPage from '../views/classes/index.vue'
import AttendancePage from '../views/attendance/index.vue'
import LeavesPage from '../views/leaves/index.vue'
import FeedbacksPage from '../views/feedbacks/index.vue'
import NoticesPage from '../views/notices/index.vue'
import PaymentsPage from '../views/payments/index.vue'
import UsersPage from '../views/users/index.vue'
import OperationLogsPage from '../views/operation-logs/index.vue'
import StudentDetail from '../views/students/Detail.vue'
import Settings from '../views/settings/index.vue'
import { getToken, getStoredUser } from '../utils/auth'

Vue.use(Router)

const viewMap = {
  Students: '学生管理', Classes: '班级管理', Attendance: '考勤记录', Leaves: '请假审批',
  Feedbacks: '作业反馈', Notices: '通知公告', Payments: '收费管理', Users: '员工管理',
  OperationLogs: '操作日志'
}

const pageComponents = { Students: StudentsPage, Classes: ClassesPage, Attendance: AttendancePage, Leaves: LeavesPage, Feedbacks: FeedbacksPage, Notices: NoticesPage, Payments: PaymentsPage, Users: UsersPage, OperationLogs: OperationLogsPage }

const children = config.navigation.slice(1).filter(item => item.enabled !== false).map(item => ({
  path: item.path.slice(1), name: item.name, component: pageComponents[item.name],
  meta: { title: viewMap[item.name], icon: item.icon, permission: item.permission }
}))

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login', component: Login, hidden: true },
    { path: '/', component: Layout, redirect: '/dashboard', children: [
      { path: 'dashboard', name: 'Dashboard', component: Dashboard, meta: { title: '工作台', icon: 'el-icon-s-home' } },
      ...children,
      { path: 'students/:id', name: 'StudentDetail', component: StudentDetail, meta: { title: '学生详情', permission: 'student:read' }, hidden: true },
      { path: 'settings', name: 'Settings', component: Settings, meta: { title: '系统设置', icon: 'el-icon-setting' }, hidden: true }
    ] },
    { path: '*', redirect: '/dashboard' }
  ]
})

router.beforeEach((to, from, next) => {
  const loggedIn = Boolean(getToken())
  if (to.path !== '/login' && !loggedIn) return next('/login')
  if (to.path === '/login' && loggedIn) return next('/dashboard')
  const permission = to.meta && to.meta.permission
  const permissions = getStoredUser()?.permissions || []
  if (permission && !permissions.includes('*') && !permissions.includes(permission)) return next('/dashboard')
  next()
})

router.afterEach(to => {
  const pageTitle = to.meta && to.meta.title
  document.title = pageTitle ? `${pageTitle} - ${config.browserTitle}` : config.browserTitle
})

export default router
